import React from 'react';

export default (props) => {
  const bodyRef = React.createRef();
  const createPdf = () => props.createPdf(bodyRef.current);
  return (
    <div className="header">
        <div className="container-fluid">
            <div className="header-body">
                <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-5">
                        <h6 className="h2 text-white d-inline-block mb-0"></h6>
                    </div>
                    <section className="col-lg-6 col-5 text-right">
                            <button onClick={createPdf} className="btn btn-sm btn-default">Download PDF</button>
                        </section>
                        <section className="pdf-body" ref={bodyRef}>
                            {props.children}
                    </section>
                    <section className="pdf-container">

                    </section>
                </div>
            </div>
        </div>
    </div>

  )
}


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/PdfContainer.js